module.exports = __webpack_public_path__ + "img/Pl1.58518506.png";